<div class="fu-slot-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-selected-fu-slot-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.fu.slot.title" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            {{ fuSlot.type }}
        </div>
    </div>
    <div class="status-container">
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuSlot.run) === 'status-error',
            }"
        >
            {{ "system-status.fu.slot.run" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-slot-run-icon"
                svgIcon="{{ getIcon(fuSlot.run) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuSlot.EEPROM) === 'status-error',
            }"
        >
            {{ "system-status.fu.slot.EEPROM" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-slot-eeprom-icon"
                svgIcon="{{ getIcon(fuSlot.EEPROM) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuSlot.ADBusy) === 'status-error',
            }"
        >
            {{ "system-status.fu.slot.ADBusy" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-slot-adbusy-icon"
                svgIcon="{{ getIcon(fuSlot.ADBusy) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
    </div>
</div>
